var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFruitBanana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 14.6049C30 18.9545 28.2722 23.1259 25.1966 26.2015C22.121 29.2771 17.9496 31.0049 13.6 31.0049C7.62805 31.0049 5.86671 28.5609 2.63071 27.2556C2.38722 27.1568 2.19232 26.9663 2.08806 26.7251C1.98379 26.4838 1.97852 26.2113 2.07338 25.9663C2.26271 25.4783 2.50671 24.8463 2.76405 24.1649C2.85599 23.9216 3.03914 23.7236 3.27464 23.6131C3.51013 23.5026 3.77943 23.4882 4.02538 23.5729C13.6574 26.8943 27.52 15.9556 20.5054 3.30627C20.4335 3.17638 20.3914 3.03214 20.3822 2.88399C20.3729 2.73584 20.3967 2.58748 20.4519 2.44966C20.507 2.31184 20.5921 2.18799 20.7009 2.0871C20.8098 1.9862 20.9398 1.91077 21.0814 1.86627C21.8894 1.5996 22.9334 1.27694 23.6867 1.04494C23.9343 0.967984 24.2021 0.990348 24.4335 1.1073C24.665 1.22425 24.8418 1.42661 24.9267 1.6716C26.6547 6.6476 30 6.95027 30 14.6049Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFruitBanana);
export default __webpack_public_path__ + "static/media/FruitBanana.8623d6e957e313108e6fa24f4ea7cea2.svg";
export { ForwardRef as ReactComponent };